// src/App.js
import React from 'react';
import './App.css';
import BadgeDisplay from './BadgeDisplay';

function App() {
  return (
    <div className="App">
      <BadgeDisplay />
    </div>
  );
}

export default App;

